export function normalize_i0(v: string) {
  if (v.indexOf('i0') === -1) {
    return v + 'i0'
  }
  return v;
}

export function normalize_rune_id(v: string) {
  if (v.indexOf(':') === -1) {
    return '1527352:1';
  }
  return v;
}
